import { Pipe, PipeTransform } from '@angular/core';

import { FilterInfo } from '@core/ui';
import { PlatformCatalogFilter } from '@mp/content-manager/plattformkataloge/data-access';

@Pipe({ name: 'mpctmPlatformCatalogsAsideFiltersSummary' })
export class PlatformCatalogsAsideFiltersSummaryPipe implements PipeTransform {
  transform(searchRequest: PlatformCatalogFilter): FilterInfo[] {
    return this.getAsideFiltersSummary(searchRequest);
  }

  private getAsideFiltersSummary(searchRequest: PlatformCatalogFilter): FilterInfo[] {
    const { catalogType, dataSources, updatedOnly } = searchRequest;
    return [
      {
        icon: 'schedule',
        title: 'Nur aktualisiert',
        isActive: !!updatedOnly,
      },
      {
        icon: 'menu_book',
        title: 'Katalogtyp',
        isActive: !!catalogType?.length,
      },
      {
        icon: 'topic',
        title: 'Datenquellen',
        isActive: !!dataSources?.length,
      },
    ];
  }
}
